// @flow
import * as React from 'react';
import ChartIcon from 'sail/ChartIcon';
import Group from 'sail/Group';
import type {IconColor} from 'sail/Icon/types';
import Box from 'sail/Box';
import {Text} from 'sail/Text';
import {defineMessages, FormattedMessage} from 'react-intl';

type RatingScaleProps = {|
  rating: number,
  maxRating: number,
  ratingColor: IconColor,
  message: string,
|};

const messages = defineMessages({
  message: {
    id: 'docsApp.components.RatingScale.message',
    description: 'Message next to rating scale',
    defaultMessage: '{message}',
  },
});

const getRatingColor = (ratingColor: number) => {
  switch (ratingColor) {
    case 1:
    case 2:
      return 'green300';
    case 3:
    case 4:
    case 5:
      return 'yellow';
    default:
      return 'gray300';
  }
};
export const RatingScale = ({
  rating,
  maxRating,
  ratingColor,
  message,
}: RatingScaleProps) => {
  const ratingIndicator = [];
  const color = ratingColor || getRatingColor(ratingColor);
  for (let i = 0; i < maxRating; i++) {
    ratingIndicator.push(
      <ChartIcon
        key={i}
        icon="circle"
        iconStyle="solid"
        color={i < rating ? color : 'gray300'}
        size={12}
      />,
    );
  }
  return (
    <Box
      flex
      style={{
        marginTop: 'auto',
        verticalAlign: 'middle',
      }}
    >
      <Group
        spacing={2}
        direction="horizontal"
        style={{
          paddingLeft: '5px',
          paddingTop: '5px',
        }}
      >
        {ratingIndicator}
      </Group>
      <Text
        weight="medium"
        size={13}
        style={{
          paddingLeft: '8px',
        }}
      >
        <FormattedMessage {...messages.message} values={{message}} />
      </Text>
    </Box>
  );
};
